import { useSpaceApi } from "@/react/hooks/useSpaceApi";
import { useSpaceResource } from "@circle-react/contexts";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { Space } from "@circle-react/types/Space";

export interface FormValues {
  cover_image: string;
}

export const useEditSpaceCover = (space: Space) => {
  const { id: spaceId } = space;
  const { updateSpace } = useSpaceApi();
  const { refetch, isLoading } = useSpaceResource({ spaceId });

  const onSubmit = async ({ cover_image }: FormValues) => {
    await updateSpace({ cover_image }, spaceId);
    await refetch();
  };

  const onDelete = async () => {
    await updateSpace(
      { cover_image: null, cover_image_visible: false },
      spaceId,
    );
    await refetch();
  };

  const isSmallScreen = useSmScreenMediaQuery();

  const {
    cover_image_url: coverImageUrl,
    cover_image_visible: isCoverImageVisible,
    thumbnail_image_url: thumbnailImageUrl,
  } = space;

  const coverImage = coverImageUrl || "";
  const thumbnailImage = thumbnailImageUrl || "";

  return {
    coverImage,
    isCoverImageVisible,
    isLoading,
    isSmallScreen,
    onDelete,
    onSubmit,
    thumbnailImage,
  };
};
